"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Meta = Meta;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _cssInJs = require("@compiled/css-in-js");

var _react = _interopRequireDefault(require("react"));

var _jsxFileName = "/home/ackwell/code/xivanalysis/tooltips/src/ui/meta.tsx",
    _this2 = void 0;

function Meta(_ref) {
  var _this = this;

  var items = _ref.items;
  return /*#__PURE__*/_react["default"].createElement(Container, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4,
      columnNumber: 13
    }
  }, items.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: index,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 5,
        columnNumber: 33
      }
    }, /*#__PURE__*/_react["default"].createElement(Name, {
      key: index,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 6,
        columnNumber: 6
      }
    }, item.name), /*#__PURE__*/_react["default"].createElement(Value, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 7,
        columnNumber: 6
      }
    }, item.value));
  }));
}

var Container = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var _ref2$as = _ref2.as,
      C = _ref2$as === void 0 ? "dl" : _ref2$as,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 87
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "esqx4d",
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 91
    }
  }, [".cc-esqx4d{display:grid;grid-template-columns:auto 1fr;margin:0;border-top:1px solid #111;padding:8px}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-esqx4d" + (props.className ? " " + props.className : ""),
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 222
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  Container.displayName = "Container";
}

var Name = /*#__PURE__*/_react["default"].forwardRef(function (_ref3, ref) {
  var _ref3$as = _ref3.as,
      C = _ref3$as === void 0 ? "dt" : _ref3$as,
      props = (0, _objectWithoutProperties2["default"])(_ref3, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 82
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "1tezioi",
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 86
    }
  }, [".cc-1tezioi{color:#ffc99a;padding-right:1em}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-1tezioi" + (props.className ? " " + props.className : ""),
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 160
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  Name.displayName = "Name";
}

var Value = /*#__PURE__*/_react["default"].forwardRef(function (_ref4, ref) {
  var _ref4$as = _ref4.as,
      C = _ref4$as === void 0 ? "dd" : _ref4$as,
      props = (0, _objectWithoutProperties2["default"])(_ref4, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 83
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "mdn430",
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 87
    }
  }, [".cc-mdn430{margin:0}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-mdn430" + (props.className ? " " + props.className : ""),
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 136
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  Value.displayName = "Value";
}